import {TweenLite} from 'gsap';
import {Beheaded} from '../../../Beheaded';
import {OpenSans} from '@nolimitcity/slot-launcher/bin/loader/font/OpenSans';
import {FontWeight} from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import {GameConfig} from "../../../config/base/GameConfig";
import { Helper } from '../../../../core/utils/Helper';

export class BeheadedPickAndClickPopUpView extends PIXI.Container {

    private _popUpTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
        align: 'center',
        wordWrap: true,
        breakWords: true,
        wordWrapWidth: 200,
        fontFamily: OpenSans.FAMILY,
        fontWeight: FontWeight.REGULAR,
        fontSize: 18,
        fill: 0xffffff,
    });

    private _popUpBg: PIXI.Sprite;
    private _popUpText: PIXI.Text;
    private _text: string;
    private _selectionId: number;

    private animationTL:gsap.core.Timeline;

    constructor(selectionId: number) {
        super();
        this._selectionId = selectionId;
        this.init();
    }

    public show(): void {
        this.animationTL = Helper.setTimeline(this.animationTL);
        if (!Beheaded.apiPlugin.isReplay) {
            this.animationTL.to(this, {
                alpha: 1,
                duration: 0.3,
                delay: 0.3,
                onComplete: () => {
                    this.hide();
                },
            });
        }
    }

    public hide(durTime: number = 0.8, delTime: number = 3): void {
        this.animationTL = Helper.setTimeline(this.animationTL);
        this.animationTL.to(this, {
            alpha: 0,
            duration: durTime,
            delay: delTime,
        });
    }

    private init(): void {
        this.alpha = 0;

        this._popUpBg = new PIXI.Sprite(Beheaded.assetLoader.getTextures('bubbleBox')[0]);
        this._popUpBg.anchor.set(0.5);
        this._popUpBg.scale.set(this._selectionId == 2 ? -0.7 : 0.7, 0.7);

        this._text = Beheaded.apiPlugin.translations.translate(this._selectionId === 1 ? 'Guaranteed 5 to 8000 times of bet' : 'Max Win or Lose it all. Chance to Win: ');

        this._popUpText = new PIXI.Text(
            this._text,
            this._popUpTextStyle
        );

        this._popUpText.anchor.set(0.5, 0.5);
        this._popUpText.position.set(0, -15);
        this.updateSizeOfBox();
        this.addChild(this._popUpBg, this._popUpText);
    }

    public updateValue(probValue:number):void{
        this._popUpText.text = this._text + this.getWinCapProbabilityText(probValue);
        this.updateSizeOfBox();
    }

    public updateSizeOfBox() {
        while ((this._popUpText.height +100) > (this._popUpBg.height)) {
            let yScale: number = this._popUpBg.scale.y;
            this._popUpBg.scale.y = yScale + 0.1;
        }
    }

    public getWinCapProbabilityText(probValue:number): string {
        let text: string = '';
        for (let i = 0; i < GameConfig.WIN_CAP_PROBABILITY.length; i++) {
            if (probValue >= GameConfig.WIN_CAP_PROBABILITY[i].min && probValue <= GameConfig.WIN_CAP_PROBABILITY[i].max) {
                text = GameConfig.WIN_CAP_PROBABILITY[i].name;
                break;
            }
        }
        return text;
    }
}
